import {
  compatibility,
  formatters,
  type MonthYear,
} from '@seek/ca-myprofile-utils';
import { useLanguage } from '@vocab/react';
import { Stack, Text } from 'braid-design-system';
import { useEffect, useState, type FC } from 'react';

import { TextDisclosureWithLinks } from '../TextDisclosureWithLinks';

const useGetFormattedRoleDate = (from: MonthYear, to?: MonthYear) => {
  const [formattedRoleDate, setFormattedRoleDate] = useState('');
  const { language: vocabLanguage } = useLanguage();
  const language =
    compatibility.getCompatibleLanguageFromLocaleString(vocabLanguage);

  useEffect(() => {
    let shouldSetFormattedRoleDate = true;
    formatters.formatRoleDate({ from, to }, language).then((result) => {
      if (shouldSetFormattedRoleDate) {
        setFormattedRoleDate(result);
      }
    });
    return () => {
      shouldSetFormattedRoleDate = false;
    };
  }, [from, language, to]);

  return formattedRoleDate;
};

export interface RoleProps {
  title: string;
  company: string;
  from: MonthYear;
  to?: MonthYear | null;
  achievements?: string | null;
}

export const Role: FC<RoleProps> = ({
  title,
  company,
  from,
  to,
  achievements,
}) => {
  const formattedDate = useGetFormattedRoleDate(from, to ?? undefined);
  return (
    <Stack space="small">
      <Text weight="strong" maxLines={1}>
        {title}
      </Text>
      <Text size="small">{company}</Text>
      {formattedDate ? (
        <Text size="small" tone="secondary" component="time">
          {formattedDate}
        </Text>
      ) : null}
      {achievements ? (
        <TextDisclosureWithLinks
          size="small"
          linesToPreview={3}
          text={achievements}
        />
      ) : null}
    </Stack>
  );
};
